<template>
  <MetricTotal
    :title="title"
    :item-id="itemId"
    :entity="entity"
    :operation="operation"
    :metric="metric"
    :owner-posts="true"
    :metric-resolver="resolver"
    :more-is-better="false"
    v-bind="$attrs"
  />
</template>

<script>
import MetricTotal from '@/components/cards/MetricTotal';
import { OPERATION, ENTITIES, SAC_STATUS_FIELDS } from '@/services/charts-service';
import proprietaryModel from '@/mixins/proprietary-model';
import { msToMinutesAndSeconds } from '@/utils/date';

export default {
  name: 'SacAverageTimeTotal',
  components: {
    MetricTotal,
  },
  mixins: [
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    operation() {
      return OPERATION.AVG;
    },
    entity() {
      return ENTITIES.SAC_STATUS;
    },
    metric() {
      return SAC_STATUS_FIELDS.statusChangeTime;
    },
  },
  methods: {
    resolver(value) {
      return msToMinutesAndSeconds(value);
    },
  },
};
</script>
